/**
 * 本地常量等配置数据
 */

// 所见视图状态
export const VIEW_STATE = {
  NONE: 0, // 默认，无状态
  LOADING: 1, // 数据加载或准备中...
  OK: 2, // 数据加载完成，有数据
  EMPTY: 3, // 数据加载完成，空数据
  WRONG: 4, // 数据加载完成，出错
};

// 性别
export const GENDER_LIST = {
  "": "未知",
  1: "男",
  2: "女",
};

// 数字对应汉字
export const NUMBER_CHINESE = {
  0: "零",

  1: "一",
  2: "二",
  3: "三",
  4: "四",
  5: "五",
  6: "六",
  7: "七",
  8: "八",
  9: "九",
  10: "十",

  11: "十一",
  12: "十二",
  13: "十三",
  14: "十四",
  15: "十五",
  16: "十六",
  17: "十七",
  18: "十八",
  19: "十九",
  20: "二十",

  21: "二十一",
  22: "二十二",
  23: "二十三",
  24: "二十四",
  25: "二十五",
  26: "二十六",
  27: "二十七",
  28: "二十八",
  29: "二十九",
  30: "三十",

  31: "三十一",
  32: "三十二",
  33: "三十三",
  34: "三十四",
  35: "三十五",
  36: "三十六",
  37: "三十七",
  38: "三十八",
  39: "三十九",
  40: "四十",

  41: "四十一",
  42: "四十二",
  43: "四十三",
  44: "四十四",
  45: "四十五",
  46: "四十六",
  47: "四十七",
  48: "四十八",
  49: "四十九",
  50: "五十",
};
